/*
 * Messenger
 *
 * Responsible for listening for new messages and updating the front-end.
 */
var Messenger = function() {
	this.interval = 10000;
	this.timeout = null;
	this.projectId = null;
	this.lastCommentId = null;
	this.unreadMessages = [];
	this.ignore = false;
}

/*
 *	Initialize the listener. Should be called when the DOM is ready.
 */
Messenger.prototype.init = function() {
	this.$unreadNumber = $('.js-num-unread');

	if ( ! this.$unreadNumber.length ) {
		return false;
	}

	this.projectId = $('.project-details').attr('rel');
	this.lastCommentId = $('#comments .comment').last().data('commentid');

	this.start();
}

/*
 * Start the listener
 */
Messenger.prototype.start = function() {
	var _this = this;

	this.timeout = setTimeout(function() {
		_this.check.apply(_this);
	}, this.interval);
}

/*
 * Stop the listener
 */
Messenger.prototype.stop = function() {
	clearInterval(this.timeout);
}

/*
 * Check for new messages for the current/all project(s)
 */
Messenger.prototype.check = function() {
	var requestData = {};
	var _this = this;

	if(!document.hasFocus()) {
		this.start();
		return;
	}

	if (this.projectId) {
		requestData.project_id = this.projectId;
		requestData.last_comment_id = this.lastCommentId || 0;
	}

	if (window.$$project_ids) {
		requestData.project_ids = $$project_ids;
	}

	$.ajax({
		url: '/get-unread-messages-count',
		type: 'GET',
		data: requestData,
		dataType: 'json',
		success: function() {
			_this.update.apply(_this, arguments);
		}
	});
}

Messenger.prototype.update = function(response) {
	this.stop();

	// Update personal messages count
	this.updateCount(response.all_unread_count);

	// Check project messages and show a notification if any
	if (response.project_unread.length) {
		this.unreadMessages = response.project_unread;

		// Emmit new comments event
		window.$eventDispatcher.$emit('comments:new', this.unreadMessages);
	}

	if (window.$eventDispatcher) {
		window.$eventDispatcher.$emit('activity:update', response.project_activity);
	}

	this.start();
}

Messenger.prototype.updateCount = function(number) {
	var $n = this.$unreadNumber;

	if( number == 0 ) {
		$n.html('');
		$n.parent().removeClass('unread');
	} else {
		$n.html('(' + number + ')');
	}

	if( number > 0 && !$n.parent().hasClass('unread') ) {
		$n.parent().addClass('unread');
	}
}

Messenger.prototype.setLastComment = function(commentId) {
	this.lastCommentId = commentId || 0;
}

Messenger.prototype.showNotification = function() {
	var _this = this;
	var msgCount = _this.unreadMessages.length;

	if (msgCount === 0 || this.ignore) {
		return false;
	}

	var tmplContext = {
		msgCount: msgCount
	};

	var $tmpl = $(tmpl($('#page-notification-template').html(), tmplContext));
	var $ntf = $('.page-notification');

	// Update the message count if the notification is already displayed
	if ($ntf.length) {
		$ntf.html($tmpl.html()).fadeIn();

		return true;
	}

	// Show new comments when the "Show" link is clicked
	$tmpl.delegate('.show-new-comments', 'click', function(e) {
		var lastUnreadMessage = -1;
		for (var i = 0; i < _this.unreadMessages.length; i++) {
			var unreadMessageId = Number(_this.unreadMessages[i]);
			window.$eventDispatcher.$emit('comments:added', unreadMessageId);
			if ( unreadMessageId > lastUnreadMessage ) {
				lastUnreadMessage = unreadMessageId;
			}
		}
		_this.setLastComment( lastUnreadMessage );

		$tmpl.fadeOut();

		e.preventDefault();
	});

	// Ignore new comments when "Ignore" link is clicked
	$tmpl.delegate('.ignore-comments', 'click', function(e) {
		_this.ignore = true;

		$tmpl.fadeOut();

		e.preventDefault();
	});

	// Display the notification
	$tmpl
		.hide()
		.appendTo($('body'))
		.fadeIn();
}

window.msgMonitor = new Messenger();

$(function() {

	// Initialize the msgMonitor
	msgMonitor.init();

	function check_for_updates(){
		var location = window.location.href.toString();

		$.get(location, function(data){
			var data = $(data);
			var new_results = data.find('#projects-list tr');
			var old_results = $('#projects-list tr');
			var old_results_parent = old_results.parent();

			// check if the html is the same
			var num_new_results = new_results.length;
			var affected_rows = 0;

			var last_appended_element = null;
			new_results.each(function(){
				var id = $(this).attr('data-id');
				var last_comment_id = $(this).attr('data-lastcomment');

				if( old_results.filter('[data-lastcomment="' + last_comment_id + '"]').length > 0 ) return;

				if( last_appended_element == null ) {
					last_appended_element = $(this).prependTo( old_results_parent );
				}else {
					last_appended_element = $(this).insertAfter( last_appended_element );
				}

				old_results.filter('[data-id="' + id + '"]').remove();

				affected_rows++;
			});

			var updated_results = $('#projects-list tr');

			if( new_results.length != updated_results.length ) {
				for(var i=new_results.length; i < updated_results.length; i++){
					updated_results.eq(i).remove();
				}
			}

			// updated the below only if there are new result(s);
			if( affected_rows > 0 ) {
				// update active count
				var old_active = $('.num-active');
				var new_active = data.find('.num-active');
				if( old_active.html() != new_active.html()) {
					old_active.html( new_active.html() );
				}

				// update footer
				var old_footer = $('.tfoot');
				var new_footer = data.find('.tfoot');
				if( old_footer.children().length == 0 ) {
					old_footer.html( new_footer.html() );
				}

				var old_pagging = old_footer.find('.pagging');
				var new_pagging = new_footer.find('.pagging');

				if( old_pagging.html() != new_pagging.html() ) {
					old_pagging.html( new_pagging.html() );
				}
			}

			init_check_for_updates();
		});
	}

	function init_check_for_updates(){
		var location = window.location;
		var page = location.pathname.toString();
		var search = location.search.toString();

		// enable auto updates only for projects pages - active and unread
		if( page != '/projects' ) return;
		if( search != "" && search != "?type=unread" && search != "?p=1" && search != "?type=unread&p=1" ) return;

		window.setTimeout(function(){
			check_for_updates();
		}, updates_interval);
	}

	//init_check_for_updates();
});
